'use es6';

export const LOCK_DOWN_REPORT = 'LOCK_DOWN_REPORT';
export const SHOW_BANNER = 'SHOW_BANNER';
export const UPDATE_REPORT = 'UPDATE_REPORT';